var _path, _line, _line2, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _circle, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBrandingIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 40,
    viewBox: "0 0 42 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.5234 10C36.5234 9.72386 36.7473 9.5 37.0234 9.5H40.0234C40.2996 9.5 40.5234 9.72386 40.5234 10V31.3043C40.5234 31.376 40.508 31.4468 40.4783 31.5119L38.9783 34.7989C38.8004 35.1888 38.2465 35.1888 38.0686 34.7989L36.5686 31.5119C36.5388 31.4468 36.5234 31.376 36.5234 31.3043V10Z",
    stroke: "white"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 37.0234,
    y1: 13.5,
    x2: 40.0234,
    y2: 13.5,
    stroke: "white"
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 37.0234,
    y1: 15.5,
    x2: 40.0234,
    y2: 15.5,
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23 16L34 16",
    stroke: "white",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20.5 12L34 12",
    stroke: "white",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M25 24L34.0234 24",
    stroke: "white",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M25 20L34 20",
    stroke: "white",
    strokeLinecap: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M19.5 28L34 28",
    stroke: "white",
    strokeLinecap: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 32L34 32",
    stroke: "white",
    strokeLinecap: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.5546 17.4205C12.5614 17.0436 12.9669 16.8096 13.2966 16.9921L14.8233 17.8369C15.1787 18.0336 15.5986 18.0777 15.9871 17.9592L17.6561 17.4503C18.0166 17.3403 18.3645 17.6536 18.2928 18.0236L17.9611 19.7366C17.8838 20.1354 17.9716 20.5484 18.2044 20.8813L19.2042 22.3113C19.4201 22.6201 19.2297 23.0478 18.8557 23.094L17.124 23.3078C16.7209 23.3576 16.3552 23.5688 16.1105 23.893L15.0595 25.2857C14.8325 25.5866 14.3669 25.5376 14.2074 25.1962L13.4689 23.6153C13.2969 23.2473 12.9831 22.9648 12.5992 22.8323L10.9498 22.2631C10.5935 22.1401 10.4962 21.6822 10.7717 21.425L12.0469 20.2341C12.3438 19.9569 12.5155 19.5711 12.5229 19.165L12.5546 17.4205Z",
    stroke: "white"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M4.88948 11.7499C4.99245 11.3657 5.24384 11.038 5.58837 10.8391L7.90202 9.50333L10.9331 7.75333C11.0815 7.66763 11.26 7.65107 11.4217 7.708L14.6003 8.82728C14.938 8.94621 15.2221 9.18203 15.4011 9.49213L22.2812 21.4088C22.6954 22.1262 22.4496 23.0436 21.7321 23.4578L13.0719 28.4578C12.3545 28.872 11.4371 28.6262 11.0229 27.9088L4.18707 16.0688C3.98816 15.7243 3.93425 15.3149 4.03722 14.9306L4.88948 11.7499Z",
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.5844,
    cy: 13.1528,
    r: 2.5,
    transform: "rotate(-30 10.5844 13.1528)",
    stroke: "white"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M4.13993 13.9825C3.06054 13.5982 2.0943 12.7182 1.77391 11.8845C0.523901 8.6835 2.88213 7.20319 3.48801 6.85338C5.87947 5.47267 8.93742 6.29205 10.3181 8.68351C11.582 10.8727 11.0024 13.6203 9.06082 15.1286",
    stroke: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6.65234 8.6V3C6.65234 1.89543 7.54777 1 8.65234 1H36.6523C37.7569 1 38.6523 1.89543 38.6523 3V9.5M6.65234 22.375V37C6.65234 38.1046 7.54777 39 8.65234 39H36.6523C37.7569 39 38.6523 38.1046 38.6523 37V34",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandingIcon);
export default __webpack_public_path__ + "static/media/brandingIcon.2091dc7e2d3e79cd71ea2a3f2df7cce6.svg";
export { ForwardRef as ReactComponent };